/**
 * Extract a human-readable message from an Eden Treaty error response.
 */
export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== 'object') return fallback

  const val = (error as { value?: unknown }).value
  if (typeof val === 'string') return val
  if (
    val &&
    typeof val === 'object' &&
    'message' in val &&
    typeof (val as { message: unknown }).message === 'string'
  ) {
    return (val as { message: string }).message
  }

  return fallback
}

/**
 * Throw an Error with a message extracted from an Eden Treaty error response.
 */
export function throwApiError(error: unknown, fallback: string): never {
  throw new Error(getApiErrorMessage(error, fallback))
}
